document.addEventListener("DOMContentLoaded", () => {
  let pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  let timeout = pageHasRecomendations ? 2000 : 0;

  setTimeout(function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");

      let sectionName = "ve-main-product";
      // let sectionName = "test-section";

      quickViewControls.forEach((control) => {
        let handle = control.getAttribute("data-product-handle");
        if (handle) {
          control.addEventListener("click", (e) => {
            e.preventDefault();
            window.axios
              .get(`/products/${handle}?sections=${sectionName}`, {})
              .then(function (response) {
                // Success
                let script_index = 2;
                let html = response.data[`${sectionName}`];

                // this section gets the correct js returned in the section rendering API call and gets the js within the document on load so that we can rerun it (eval)
                let script_parts = html.split("<script>");
                // console.log("🚀 ~ file: product-quick-view-modal.js:29 ~ html", html)
                script = script_parts[script_index].replace("</script>", "");
                script = script.replace("</div>", "");
                script = script.replace('document.addEventListener("DOMContentLoaded", function() {', "");
                let closingBraceLocation = script.lastIndexOf("})");
                script = script.substring(0, closingBraceLocation)

                if (quickViewModalInner && html) {
                  quickViewModalInner.innerHTML = html;

                  eval(script);

                  

                  // init sliders
                  // let gallery_thumbs_swiper = new window.swiper(
                  //   ".inner .thumb-swiper",
                  //   {
                  //     spaceBetween: 15,
                  //     slidesPerView: 4,
                  //     freeMode: true,
                  //     watchSlidesProgress: true,
                  //     breakpoints: {
                  //       992: {
                  //         slidesPerView: 4,
                  //         direction: "vertical",
                  //       },
                  //     },
                  //   }
                  // );

                  let gallery_swiper = new window.swiper(
                    ".inner .main-swiper",
                    {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      // thumbs: {
                      //   swiper: gallery_thumbs_swiper,
                      // },
                      on: {
                        init: function () {

                          // let check_width = setInterval(() => {
                          //   setThumbHeight()
                          // }, 200);

                          // function setThumbHeight() {
                          //   let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                          //   let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                          //   let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                          //   let main_swiper_width = main_swiper_slide.offsetWidth;

                          //   main_swiper_slide.style.height = main_swiper_width + 'px';

                          //   if (main_swiper_width > 0) {

                          //     clearInterval(check_width);

                          //     thumb_swiper.style.cssText = "position: relative;opacity:1";

                          //     if (window.innerWidth > 991.98) {
                          //       thumb_swiper.style.height = main_swiper_width + 'px';
                          //     }
                          //   }
                          // }

                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          // window.addEventListener('resize', () => {

                          //   let main_swiper_slide = document.querySelector('.inner .main-swiper');
                          //   let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                          //   let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                          //   let main_swiper_width = main_swiper_slide.offsetWidth;

                          //   main_swiper_slide.style.height = main_swiper_width + 'px';

                          //   if (window.innerWidth > 991.98) {

                          //     thumb_swiper.style.height = main_swiper_width + 'px';

                          //   }

                          // });

                        }
                      },
                    }
                  );

                  // add listeners to product form
                  let productForm = quickViewModalInner.querySelector(
                    '[action="/cart/add"]'
                  );

                  if (productForm) {
                    productForm.addEventListener("submit", function (e) {
                      e.preventDefault();

                      let quantity = productForm.querySelector(
                        "input.quantity-selector"
                      ).value;
                      let id = productForm.querySelector("#product-id").value;

                      if (quantity && id) {
                        window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                      }
                    });
                  }

                  // add listener for read more
                  const prod_desc = document.querySelector("#main-product .product-description-container .product-desc");
                  // const pd_length = prod_desc.innerHTML.replace(/(<([^>]+)>)/gi, "").length;
                  const pd_height = prod_desc.offsetHeight;
                  const read_more = document.querySelector("#main-product .product-description-container .read-more");
                  if (window.innerWidth > 767.98) {
                  
                    if (pd_height >= 75) {
                      read_more.style.display = "block";
                      read_more.addEventListener('click', () => {
                        if (prod_desc.classList.contains("truncate")) {
                          prod_desc.classList.remove('truncate')
                          read_more.innerHTML = "Read less"
                        } else {
                          prod_desc.classList.add('truncate')
                          read_more.innerHTML = "Read more"
                        }
                      })
                    } else {
                      prod_desc.classList.remove('truncate');
                      read_more.style.display = "none";
                    }
                  
                  } else {
                    if (pd_height >= 75) {
                      read_more.style.display = "block";
                      read_more.addEventListener('click', () => {
                        if (prod_desc.classList.contains("truncate")) {
                          prod_desc.classList.remove('truncate')
                          read_more.innerHTML = "Read less"
                        } else {
                          prod_desc.classList.add('truncate')
                          read_more.innerHTML = "Read more"
                        }
                      })
                    } else {
                      prod_desc.classList.remove('truncate');
                      read_more.style.display = "none";
                    }
                  }

                  // Show quick view modal
                  quickViewModal.classList.add("active");
                }
              })
              .catch(function (error) {
                // handle error
                window.log("Error:", error);
              })
              .then(function () {
                // always executed
                //console.log('🚀 QUICKVIEW READY...');
                quickViewModal.classList.add("active");
                window.log("Complete");
              });
          });
        }
      });

      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
      });
    }
  }, timeout);
});
